import type { PlaceHolderProps } from './types'

export const TERMS_AND_PRIVACY =
  'I agree to receive calls or text messages (including autodialed marketing messages and prerecorded or artificial voice calls), ' +
  'from or on behalf of RentSpree, its real estate agents, property managers, and landlords (“Partners”). Consent is not a condition of using the services. ' +
  // eslint-disable-next-line quotes
  "Msg & data rates apply. RentSpree may share your contact information with its Partners to assist you in your property search. RentSpree's "

export const EMAIL_AGREEMENT =
  'I agree to receive emails from or on behalf of RentSpree and its Partners related to properties that I may be interested in. '

export const EMAIL_AGREEMENT_TERMS_AND_PRIVACY =
  'I agree to receive emails from or on behalf of RentSpree, its real estate agents, property managers, and landlords related to properties that I may be interested in. '

export const PLACEHOLDER: PlaceHolderProps = {
  agentProfile: {
    FULL_NAME: 'First and last Name',
    EMAIL: 'hello@email.com',
    PHONE: '(000) 000-0000',
    MESSAGE: `Hi {agent_name}, 
I’m looking for a rental home. Could you please contact me?`,
  },
}
